import { Component, inject, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslationService } from '../../services/translation.service';

@Component({
  selector: 'app-offshore',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './offshore.html',
  styleUrl: './offshore.scss',
})
export class Offshore {
  ts = inject(TranslationService);
  t = this.ts.t;

  vessels = computed(() => [
    { name: this.t().offshore_vessel1 },
    { name: this.t().offshore_vessel2 },
    { name: this.t().offshore_vessel3 },
    { name: this.t().offshore_vessel4 },
    { name: this.t().offshore_vessel5 },
    { name: this.t().offshore_vessel6 },
    { name: this.t().offshore_vessel7 },
  ]);

  detections = computed(() => [
    this.t().offshore_det1, this.t().offshore_det2, this.t().offshore_det3,
    this.t().offshore_det4, this.t().offshore_det5, this.t().offshore_det6,
    this.t().offshore_det7, this.t().offshore_det8, this.t().offshore_det9,
    this.t().offshore_det10, this.t().offshore_det11, this.t().offshore_det12,
    this.t().offshore_det13,
  ]);
}